/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Category_CompletenessInputs */

const en_pdf_cv_review_category_completeness = /** @type {(inputs: Pdf_Cv_Review_Category_CompletenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completeness`)
};

const de_pdf_cv_review_category_completeness = /** @type {(inputs: Pdf_Cv_Review_Category_CompletenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständigkeit`)
};

/**
* | output |
* | --- |
* | "Completeness" |
*
* @param {Pdf_Cv_Review_Category_CompletenessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_category_completeness = /** @type {((inputs?: Pdf_Cv_Review_Category_CompletenessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Category_CompletenessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_category_completeness(inputs)
	return en_pdf_cv_review_category_completeness(inputs)
});